import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import PendingPayment from 'app/src/payments/PendingPayment';

/**
 * Class definition for a User Defined payment
 */
export default class UserDefinedPayment extends PendingPayment {
  /**
   * Constructor
   * @param amount {Decimal}  The amount of the user defined payment
   * @param paymentTypeID {Integer} The Payment Type ID for the Payment
   * @param saleID {Number}   The ID of the sale for the payment
   */
  constructor(amount, paymentTypeID, saleID = 0) {
    super(amount, paymentTypeID, saleID);

    this._allowMultiple = false;
  }
}
